// Generic error component.
export const ErrorComponent = ({error}) => {
    return <h3>An Error Occurred: {error.errorCode}</h3>;
}